import { tv } from 'tailwind-variants';

export const toastVariants = tv({
  base: 'flex min-h-14 items-center gap-4 px-4 py-2 text-base',
  variants: {
    type: {
      error: 'bg-red text-white',
      info: 'bg-ocean-200 text-white',
      success: 'bg-green text-white',
      warning: 'bg-yellow text-grey-900'
    }
  },
  defaultVariants: {
    type: 'info'
  },
  slots: {
    description: 'w-max max-w-[400px]',
    closeButton: 'rounded p-2 transition-colors hover:bg-white/90 hover:text-grey-800'
  }
});
